/* constants */
export const AFRICA_STR = 'Africa';

export const DEFAULT_THEME = 'RdBu';

export const DEFAULT_THEMES = ['RdBu', 'BuRd'];
